import React from 'react'

const SvgTelescopeOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.666 2.035a1 1 0 011.226.715l2.074 7.814a1.012 1.012 0 01-.708 1.238l-3.876 1.049a1.004 1.004 0 01-1.226-.715l-2.073-7.814a1.017 1.017 0 01.708-1.239l3.875-1.048zm-.833 8.622l-1.566-5.901 1.949-.527 1.565 5.9-1.948.528zM4.302 14.29l2.666-.74c.037-.01.074-.019.111-.025.145.67.482 1.27.95 1.736l-2 5.392-.003.006c-.02.057-.316.963.623 1.275.91.302 1.239-.524 1.256-.57l.002-.005 1.9-5.145c.182.036.37.059.56.066l2.193 5.127c.03.069.066.134.117.189.168.18.62.567 1.232.314.596-.246.61-.824.588-1.058a.63.63 0 00-.054-.195l-2.134-4.878A3.498 3.498 0 0014 12.7l1.094-.31-2.04-7.8L6.276 6.42c-.528.142-.838.717-.705 1.253l-2.829.765a1.012 1.012 0 00-.708 1.239l1.035 3.9a1 1 0 001.233.714zM7 8.282l4.628-1.235.741 2.775a3.5 3.5 0 00-5.068 1.537l-2.557.732-.525-1.981 3.024-.828-.243-1zm3.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3z'
    />
  </svg>
)

export default SvgTelescopeOutline
